import React, { Component } from 'react';
import { GenericSimpleButton, GenericModal } from 'com-gyf-webcore-userinterfacecomponents';
import GruposAfinidadSelector from './GruposAfinidadSelector.jsx';
import GruposAfinidadSeleccionadas from './GruposAfinidadSeleccionadas.jsx';

//import SucursalesSeleccionadas from './SucursalesSeleccionadas.jsx';
import CheckDefecto from "../../../../../Common/Components/CheckDefecto.jsx";
import OpcionDefecto from "../../../../../Common/Components/OpcionDefecto.jsx";

class GruposAfinidadLink extends Component {
    OpenBranches() {
        $("#GruposAfinidadSelector").modal();
    }

    render() {
        let data = this.props.data.GET_GRUPO_AFINIDAD_ADMINISTRADORA;
        const arrayAux = data.filter(d => d.Checked);
        const { selectCheckBox, selectCombo, asociaGA } = this.props;
        let errorSave = this.props.data.errorSave;
        if (data.find(x => x.Checked === true) !== undefined && errorSave) {
            errorSave = false;
        }

        return (
            data.length > 0 &&
            <div className="row top-separator-xs">
                <div className="col-md-3">
                    <label className="label-primary">{"Grupos de Afinidad"}</label>
                    <br />
                </div>

                <div className="col-xs-12">
                    <CheckDefecto
                        nombre={"Asociar a Grupo de Afinidad"}
                        check={this.props.asociaGA}
                        referencia={"ASOGRUA"}
                        selectCheckBox={(event) => selectCheckBox("AsociaGrupoAfinidad", event.target.checked)}
                    />
                </div>
               { asociaGA &&
                <div className="col-md-3">
                    <GenericSimpleButton text="Seleccionar..." buttonType="button" buttonClass="btn btn-link no-padding" onClick={this.OpenBranches} />
                    {errorSave === true ? <label className="error">Por favor selecciona al menos un grupo de afinidad</label> : undefined}

                    <GenericModal
                        type={"WITH_COMPONENTS_SAVE_CANCEL_SM"}
                        className="modal fade-out" id="GruposAfinidadSelector"
                        header="Grupos de Afinidad"
                        component={
                            <GruposAfinidadSelector
                            data={data}
                            edicion={this.props.data.edicion}
                            saveSelectedBranches={this.props.saveSelectedBranches}
                            cancelSelectedBranches={this.props.cancelSelectedBranches}
                            />}
                    />
                </div>}

                            <GruposAfinidadSeleccionadas data={this.props.data} removeSelectedBranch={this.props.removeSelectedBranch} showMoreBranches={this.props.showMoreBranches} showLessBranches={this.props.showLessBranches} />
                

                <div className="col-xs-12">
                    {this.props.data.AsociaGrupoAfinidad && <OpcionDefecto
                        infoData={arrayAux}
                        referencia={"GrupoAfinidadDefaultId"}
                        valorCombo={this.props.data.GrupoAfinidadDefaultId}
                        valorChecked={this.props.data.GrupoAfinidadDefaultInterfaz}
                        selecciono={arrayAux.length}
                        selectCombo={(value) => selectCombo("GrupoAfinidadDefaultId", value)}
                        selectCheckBox={(value) => selectCheckBox("GrupoAfinidadDefaultInterfaz", value)}
                    />}

                    {(this.props.data.AsociaGrupoAfinidad && !this.props.data.ERROR_PRODUCT["seleccionoGrupoAfinidad"] && arrayAux.length==0)
                    && <label className="error">{"Debe seleccionar al menos un grupo de afinidad."}</label>}

                </div>
            </div>
        );
    }
};

export default GruposAfinidadLink;